import type { FC } from 'react';

import { SESSION_UNAVAILABLE_COPY } from '@/constants/auth';
import { useStaffSession, useStageGuard } from '@/hooks/auth';

import { Button } from 'components/ui/Button';
import { Eyebrow } from 'components/ui/Eyebrow';

import type { TAdmittedGateProps } from './AdmittedGate.props';

const AdmittedGate: FC<TAdmittedGateProps> = ({ children }) => {
  const session = useStageGuard('ready');
  const { isError, isFetching, refetch } = useStaffSession();

  const onRetry = () => {
    refetch();
  };

  if (!session && isError) {
    return (
      <div className="flex min-h-screen flex-1 flex-col items-center justify-center px-12 text-center">
        <Eyebrow>{SESSION_UNAVAILABLE_COPY.title}</Eyebrow>
        <p className="text-body text-text-primary mt-2">{SESSION_UNAVAILABLE_COPY.description}</p>
        <Button className="mt-3" isLoading={isFetching} onClick={onRetry}>{SESSION_UNAVAILABLE_COPY.retry}</Button>
      </div>
    );
  }

  if (session?.stage !== 'ready') {
    return null;
  }

  return children;
};

export {
  AdmittedGate,
};
